exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__uploadMsg___14Ib3{width:7rem;text-align:center;margin:0 auto;margin-top:2rem}.style__uploadIcon___1fFVf{text-align:center;margin-top:1rem}", "", {"version":3,"sources":["/./containers/disease/style.css"],"names":[],"mappings":"AAAA,0BACC,WAAY,AACZ,kBAAmB,AACnB,cAAe,AACf,eAAiB,CACjB,AAED,2BACC,kBAAmB,AACnB,eAAiB,CACjB","file":"style.css","sourcesContent":[".uploadMsg {\n\twidth: 7rem;\n\ttext-align: center;\n\tmargin: 0 auto;\n\tmargin-top: 2rem;\n}\n\n.uploadIcon {\n\ttext-align: center;\n\tmargin-top: 1rem;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"uploadMsg": "style__uploadMsg___14Ib3",
	"uploadIcon": "style__uploadIcon___1fFVf"
};


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/css-loader?modules&sourceMap&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!/data/www/SGDBackend-Nex2/~/postcss-loader!./containers/disease/style.css
// module id = 556
// module chunks = 0